export enum WfdPriorityType {
    None = 'None',
    Vip = 'VIP',
    Referral = 'Referral'
}

// This enum is used to represent the WFD priority types from the backend.
export enum WfdPriorityTypeValue {
    None = 0,
    Vip = 1,
    Referral = 2
}
